import { createStyles, Theme } from '@material-ui/core';
import { scrollStyles } from '@core/theme';

export default ({ typography, palette: { colors } }: Theme) =>
  createStyles({
    '@global': {
      '*': {
        margin: 0,
        padding: 0,
        border: 0,
        fontWeight: 400,
      },
      html: {
        overflow: 'hidden',
      },
      body: {
        fontFamily: typography.fontFamily,
        color: colors.text,
        overflow: 'hidden',
        backgroundColor: 'white',

        '& strong': {
          color: 'black',
          cursor: 'pointer',
          fontWeight: 500,
        },

        '& *': scrollStyles,
      },
      '#root': {
        overflow: 'hidden',
      },
      a: {
        display: 'inline-flex',
        color: 'inherit',
        outline: 'none',
        textDecoration: 'none',
        cursor: 'pointer',
      },
      span: {
        lineHeight: 1.2,
      },
      input: {
        '&::-ms-clear, &::-ms-reveal': {
          display: 'none',
        },
      },
    },
    root: {
      overflow: 'hidden',
    },
  });
